module.exports = __webpack_public_path__ + "img/logo-telefonica0.683c5103.png";